export default __webpack_public_path__ + "static/media/home-interior-design-portfolio-img02.f007a671.jpg";